// Module
var code = `<div class="product-media">
  <img class="product-img" alt="{{attrImageAlt}}" src="{{attrImageSrc}}" />
</div>
<div class="product-meta">
  <h3 class="product-name">{{name}}</h3>
  <p class="product-provenance">
    <span class="product-origin">{{origin}}</span>
    <span class="product-mass">{{mass}}</span>
  </p>
  <div class="product-row">
    <p class="product-valuation">
      <span class="product-valuation__label">{{priceLabel}}</span>
      <span class="product-price">{{price}}</span>
      {{#sale}}
      <s class="product-price product-price--was"
        ><span class="sr-only">was </span>{{compareAtPrice}}</s
      >
      {{/sale}}
    </p>
    <button
      type="button"
      class="product-acquire"
      data-action="add-to-cart"
      data-product-id="{{%attrProductId%}}"
      data-variant-id="{{%attrVariantId%}}"
      aria-label="{{%attrAcquireLabel%}}"
    >
      <img class="product-acquire__icon" src="{{attrAddToCartIconSrc}}" alt="" />
      <span class="product-acquire__label">{{addToCartLabel}}</span>
    </button>
  </div>
</div>
`;
// Exports
module.exports = code;